import { ALL_TAGS } from '@esentai/core/features/campaigns/calendarEvent/consts/tags';

export const getOptions = () => ALL_TAGS.map(tag => ({ key: tag, label: tag }));
